module.exports = __webpack_public_path__ + "media/reskin-images/icon--edit-ec1f69b9.svg";